<template>
  <div class="vowels-test">
    <!-- <div class="hoverable-button">
      kaftor
    </div> -->
    <div style="color: green;">
      vowels test dev
    </div>
    <select v-model="vowelToDetect" class="select">
      <option v-for="(vowel, i) of vowelsArr" :value="vowel" :key="i">
        {{ vowel }}
      </option>
    </select>
    <div class="left">
      > left
    </div>
    <div class="right">
      right <
    </div>
  </div>
</template>

<script>
import appConstants from '@/config/constants';

export default {
  name: 'vowels-test',
  data() {
    return {
      vowelToDetect: appConstants.vowels.VOWEL_O,
      vowelsArr: Object.keys(appConstants.vowels)
    };
  },
  methods: {
    handleVowelDetected(vowel) {
      // debug
      let color;
      if (Math.random() > 0.3) {
        color = 'green';
      } else if (Math.random() > 0.6) {
        color = 'blue';
      } else {
        color = 'yellow';
      }
      // console.log(
      //   `%c success! detected ${vowel}`,
      //   `background: ${color}; color: black`
      // );
    },
    getVowelToDetect() {
      return this.vowelToDetect;
    }
  }
};
</script>

<style lang="scss" scoped>
.hoverable-button {
  position: fixed;
  top: 20vh;
  background-color: #fff;
  padding: 50px;
}

.left,
.right {
  padding: 20px;
  position: fixed;
  background-color: black;
  color: #fff;
  top: 70vh;
  font-size: 30px;
}

.right {
  left: 0;
}

.left {
  right: 0;
}
</style>
